/**
 * Firebase project config — `john-morrell`.
 * Shared with morrell_dev_2; mdev3 reuses the same project for auth + Firestore.
 * Public keys; safe to commit (Firebase web config is not a secret).
 */
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB4ooZgS4RYPKQ1qrxI8MtBc-3B4a6K3zs',
  authDomain: 'john-morrell.firebaseapp.com',
  projectId: 'john-morrell',
  storageBucket: 'john-morrell.appspot.com',
  messagingSenderId: '810348637006',
  appId: '1:810348637006:web:5b0ac4aff84ecf49520c1f',
  measurementId: 'G-YMS8E7N359',
} as const;

export const FIREBASE_PROJECT_ID = FIREBASE_CONFIG.projectId;

/**
 * Google Maps JavaScript API key for the same `john-morrell` GCP project.
 * It happens to be identical to the Firebase apiKey above — both point at
 * the same project — but exposed separately so consumers don't import a
 * Firebase config to load Maps.
 */
export const GOOGLE_MAPS_API_KEY = FIREBASE_CONFIG.apiKey;
